export const yearBlockHeight = 812;
export const yearBlockWrapperWidth = 124;
export const yearBlockWidth = 106;
export const monthBlockHeight = 64;
export const quarters = [1, 2, 3, 4];
export const quarterMonthStart = [1, 4, 7, 10];
